// extracted by mini-css-extract-plugin
module.exports = {"panel":"SeeInActionPanel_panel__PLOsk","video":"SeeInActionPanel_video__ve9v3"};